import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Lessons from "./components/Lessons";
import Booking from "./components/Booking";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  const scrollToBooking = () => {
    const bookingSection = document.getElementById('booking');
    bookingSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <Header onBookingClick={scrollToBooking} />
      <Hero onBookingClick={scrollToBooking} />
      <About />
      <Lessons onBookingClick={scrollToBooking} />
      <Booking />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;